module.exports = __webpack_public_path__ + "static/media/folder.b4fd4250.svg";